import React, { useState } from "react";
import styled from "styled-components";
import { Link, Redirect, useHistory } from "react-router-dom";
import "react-phone-number-input/style.css";
import { Header } from "../components";
import google from "../assets/google.png";
import facebook from "../assets/Logo_facebook.svg";
import twitter from "../assets/logo_twitter.svg";
import arrow from "../assets/arrow.png";

import { ToastContainer, toast } from "react-toastify";
import { authenticate, isAuth } from "../helpers/auth";
import axios from "axios";
import { GoogleLogin } from "react-google-login";

const SignIn = () => {
  const history = useHistory();
  const [email, setemail] = useState("");
  const [password, setpassword] = useState("");

  // Send google token
  // const sendGoogleToken = (tokenId) => {
  //   axios.post("https://yartirush.herokuapp.com/api/auth/login");
  // };

  // // Submit data backend
  // const handleSubmit = async (e) => {
  //   e.preventDefault();
  //   if (email && password) {
  //     axios
  //       .post("https://yartirush.herokuapp.com/api/auth/login", {
  //         email,
  //         password,
  //       })

  //       .then((res) => {
  //         authenticate(res, () => {
  //           console.log(res);
  //           setemail("");
  //           setpassword("");
  //         });
  //         console.log(res);

  //         // If authinticate but not admin redirect to private
  //         // If admin redirect to /admin
  //         // isAuth() && isAuth().role === "admin"
  //         //   ? history.push("/admin")
  //         //   : history.push("/private");
  //         history.push("/");
  //         toast.success(`Hey , welcome back`);
  //       })
  //       .catch((err) => {
  //         setemail("");
  //         setpassword("");
  //         // console.log(err.response);
  //         toast.error('this user dosen"t exist');
  //       });
  //     // console.log(reponse);
  //   } else {
  //     toast.error("please fill all fields");
  //   }
  // };

  return (
    <>
      <Header />
      <Wrapper>
        {isAuth() ? <Redirect to="/" /> : null}
        <ToastContainer />
        <div className="sign__Wrapper">
          <div className="section-center text-center">
            <div className="sign__up_wrapper">
              <div className="sign__up_method">
                <a href="https://google.com/">
                  <div className="sign__up_google">
                    <img src={google} alt="google" />
                    Sign up with google
                  </div>
                </a>
                <a href="https://www.facebook.com/">
                  <div className="sign__up_social">
                    <img src={facebook} alt="facebook" />
                  </div>
                </a>
                <a href="https://twitter.com/">
                  <div className="sign__up_social">
                    <img src={twitter} alt="twitter" />
                  </div>
                </a>
              </div>

              <form className="sign__up_form">
                <div className="signUp__process">
                  <input
                    type="email"
                    placeholder="Email Address"
                    className="signup__mail__proc"
                    onChange={(e) => setemail(e.target.value)}
                    value={email}
                  />
                  <input
                    type="password"
                    placeholder="Password"
                    className="signup__mail__proc"
                    onChange={(e) => setpassword(e.target.value)}
                    value={password}
                  />
                </div>

                <Link to="/forgotpass">
                  <p>Forgot your password?</p>
                </Link>

                {/* <Link to="/"> */}
                <button className="signUp__btn">
                  Create Account{"  "} <img src={arrow} alt="arrow" />
                </button>
                {/* </Link> */}
              </form>

              <p className="wrapper__footer">
                Don’t have an account?
                <Link to="/register">
                  <span> Sign up </span>
                </Link>
              </p>
            </div>
          </div>
        </div>

        <div className="Svg">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320">
            <path
              fill="#E5EDFC"
              fill-opacity="1"
              d="M0,320L1440,64L1440,0L0,0Z"
            ></path>
          </svg>
        </div>
      </Wrapper>
    </>
  );
};

// <svg width="750" height="791" viewBox="0 0 750 791" fill="none" xmlns="http://www.w3.org/2000/svg"> <rect x="0.653931" y="402.157" width="700" height="700" rx="100" transform="rotate(-35 0.653931 402.157)" fill="#1E266D" fill-opacity="0.05"/> </svg>

const Wrapper = styled.section`
  .sign__Wrapper {
    background: #e5edfc;
    width: 100vw;
    height: 31rem;
    position: relative;
  }

  .sign__up_wrapper {
    width: 530px;
    margin: auto;
    height: 720px;
    background: #ffffff;
    border-radius: 21px;
    padding-top: 200px;
    text-align: left;
    padding: 25px 35px;
    z-index: 999;
    transform: translateY(60px);
  }
  .sign__Up_hero_wrap {
    background: #e5edfc;
    width: 100vw;
    height: 50rem;
  }

  .Svg {
    margin: sign__Up_hero_wrap;
  }

  .sign__up_method {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 360px;
    margin-top: 40px;
  }

  .sign__up_method a {
    text-decoration: none;
  }

  .sign__up_google {
    background: #6300ff;
    border-radius: 5px;
    width: 235px;
    height: 50px;
    font-family: Manrope;
    font-style: normal;
    font-weight: bold;
    font-size: 16px;
    line-height: 22px;
    color: #ffffff;
    display: flex;
    align-items: center;
    img {
      margin-left: 15.6px;
      margin-right: 15.6px;
    }
  }
  .sign__up_social {
    background: #6300ff;
    border-radius: 5px;
    width: 50px;
    height: 50px;
    display: flex;
    align-items: center;
    padding-left: 18px;
  }

  form.sign__up_form {
    margin-top: 60px;
    h1 {
      font-family: Nunito Sans;
      font-style: normal;
      font-weight: 800;
      font-size: 20px;
      line-height: 27px;
      text-align: center;
      color: #596278;
      margin-top: 26px;
    }
    p {
      margin-bottom: -15px;
      font-family: "Manrope Medium";
      font-weight: 500;
      margin-top: 15px;
      color: #1239ff;
      font-size: 16px;
    }
  }

  .signUp__name {
    input {
      background: #ffffff;
      border: 1.5px solid #dbe0eb;
      box-sizing: border-box;
      border-radius: 4px;
      width: 100%;
      height: 45px;
      margin-right: 10px;
      padding-left: 20px;
      outline: none;
      margin-top: 24px;
    }
  }
  .signUp__process {
    input {
      background: #ffffff;
      border: 1.5px solid #dbe0eb;
      box-sizing: border-box;
      border-radius: 4px;
      width: 100%;
      height: 45px;
      display: block;
      outline: none;
      padding-left: 20px;
    }
  }

  .signup__mail__proc {
    margin-top: 10px;
  }

  button.signUp__btn {
    background: #1239ff;
    border-radius: 4px;
    font-family: Manrope;
    font-style: normal;
    font-weight: 800;
    font-size: 18px;
    line-height: 25px;
    color: #ffffff;
    width: 100%;
    height: 50px;
    border: none;
    outline: none;
    margin-top: 30px;
  }
  p.wrapper__footer {
    font-family: Manrope;
    font-style: normal;
    font-weight: normal;
    font-size: 18px;
    line-height: 25px;
    letter-spacing: 0.217059px;
    color: #393f4d;
    margin-top: 41px;
    a {
      text-decoration: none;
      font-family: Manrope;
      font-style: normal;
      /* font-weight: normal; */
      font-size: 18px;
      line-height: 25px;
      letter-spacing: 0.217059px;
      color: #1239ff;
      font-weight: 700;
    }
  }

  @media screen and (max-width: 768px) {
    .sign__up_wrapper {
      width: 100%;
      margin: auto;
      height: 720px;
      background: #ffffff;
      border-radius: 21px;
      padding-top: 200px;
      text-align: left;
      padding: 25px 25px;
      z-index: 999;
      transform: translateY(140px);
    }

    .sign__up_method {
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 100%;
      margin-top: 40px;
    }
  }
`;

export default SignIn;
